import React from 'react'
import Kpirepairdownload from '../../components/kpirepairreportcomponent/Kpirepairdownload'

function  Kpirepairfile({renderPageContent}) {
    return (
        <>
                        <Kpirepairdownload renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpirepairfile